<div
  *ngIf="(value || value === 0); else emptyValue"
  class="number-decimal-column-container inline-flex gap-1"
  [class.flex-row-reverse]="unitPosition === 'right'"
>
  <span *ngIf="unit" class="unit">{{ unit }}</span>
  <span class="value">{{ value | numberLocalDecimal : "" : decimal }}</span>
</div>
<ng-template #emptyValue>
  <span *ngIf="emptyValueDisplay">{{ emptyValueDisplay }}</span>
</ng-template>
